export const justNumbersAndLetters = (e) => {
  //numeros y letras
  //        const value = e.target.value.replace(/\s+/g, " ");
  e.target.value = e.target.value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ]/g, '').toUpperCase();
};
export const numbersAndLettersAndGuion = (e) => {
  //numeros y letras + caracteres especiales
  //        const value = e.target.value.replace(/\s+/g, " ");
  e.target.value = e.target.value.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ-]/g, '').toUpperCase();
};
//solo numeros
export const justNumbers = (e) => {
  e.target.value = e.target.value.replace(/\D/g, '').replace(/\s+/g, ' ').replace(/^\s+/, '');
};

//solo letras permite
export const justLetters = (e, inUppercase = true) => {
  e.target.value = e.target.value
    .replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '')
    .replace(/\s+/g, ' ')
    .replace(/^\s+/, '');

  // .toUpperCase();
  if (inUppercase) {
    e.target.value = e.target.value.toUpperCase();
  }
};
//solo letras y sin acento
export const justLettersWithoutAccent = (e, inUppercase = true) => {
  e.target.value = e.target.value
    .replace(/[^a-zA-ZñÑ\s]/g, '')
    .replace(/\s+/g, ' ')
    .replace(/^\s+/, '');

  if (inUppercase) {
    e.target.value = e.target.value.toUpperCase();
  }
};
export const fornameTheme = (e) => {
  //solo no permite carcteres especiales ni números
  e.target.value = e.target.value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, '');
};
export const returnData = async (response) => {
  const data = await response.json();

  if (Object.keys(data).length === 0) {
    return [];
  }
  return data;
};

//limpia espacios en blanco
export const streamData = (data) => {
  if (typeof data === 'object') {
    Object.entries(data).forEach(([key, value]) => {
      if (typeof value === 'string') data[key] = value.trim();
    });
  }
  if (typeof data === 'string') {
    data = data.trim();
    return data;
  }
};

export const formatDateWithHour = (fecha, showHour = true) => {
  const date = new Date(fecha);
  const fechaFormateada = date.toLocaleDateString('es-MX');
  const hora = date.toLocaleTimeString('es-MX', {
    hour: '2-digit',
    minute: '2-digit',
  });

  return showHour ? `${fechaFormateada} ${hora}` : `${fechaFormateada}`;
};

//formaro año-mes-dia
export const formatDate = (date) => {
  if (!date) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const formatCreatedAt = (createdAt) => {
  if (!createdAt) return '---';
  return new Date(createdAt).toLocaleString('es-MX');
};
export const formatCreatedAtToDate = (createdAt) => {
  if (!createdAt) return '---';
  return new Date(createdAt).toLocaleDateString('es-MX');
};
export const formatCreatedAtToTime = (createdAt) => {
  if (!createdAt) return '---';
  return new Date(createdAt).toLocaleTimeString('es-MX');
};
export const toDateStr = (isoStr) => {
  return isoStr ? isoStr.split('T')[0] : '';
};

export const returnDataBlob = async (response, prefix) => {
  const folio = response.headers.get('X-Certificate-Folio') || `${prefix}-EMITIDO`;
  const id= response.headers.get('X-Certificate-Id')??'' ;
  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);
  return { folio: folio, blob: blob, url: url, existeUnCertificadoVigente: false ,id:id};
};
export const dowloadPdf = async (blob, type, folio) => {
  const downloadUrl = window.URL.createObjectURL(blob);
  const cleanType = (type || 'CERTIFICADO').toString().toUpperCase();
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = `Certificado_${cleanType}_${folio}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const downloadXml = async (blob, type, folio) => {
  const downloadUrl = window.URL.createObjectURL(blob);
  const cleanType = (type || 'CERTIFICADO').toString().toUpperCase();
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.download = `Certificado_${cleanType}_${folio}.xml`;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const setSystemColors = (primaryColor, secondaryColor) => {
  document.documentElement.style.setProperty('--primary-color', primaryColor || '#1F2B68');
  document.documentElement.style.setProperty('--secondary-color', secondaryColor || '#4A5DB7');
};

export const getSystemColors = () => {
  const styles = getComputedStyle(document.documentElement);
  const primaryColor = styles.getPropertyValue('--primary-color').trim();
  const secondaryColor = styles.getPropertyValue('--secondary-color').trim();
  return {
    primaryColor,
    secondaryColor,
  };
};
export const setPrimaryColor = (primaryColor) => {
  document.documentElement.style.setProperty('--primary-color', primaryColor || '#1F2B68');
};

export const setSecondaryColor = (secondaryColor) => {
  document.documentElement.style.setProperty('--secondary-color', secondaryColor || '#1F2B68');
};

export const isNumber = (value) => {
  return !(Number.isNaN(value) || value === '');
};

export const formatOptionsForSelect = (
  data = [],
  keyField,
  valueField,
  labelOptionDefault = 'Elige una opción'
) => {
  if (!Array.isArray(data)) return [];

  const options = data.map((item) => ({
    key: item[keyField],
    value: item[valueField],
  }));

  const extra = { key: '', value: labelOptionDefault };
  return extra ? [extra, ...options] : options;
};

//formatSearch
export const formatDataSearch = (
  searchFilter = [],
  searchValue = '',
  pageData = { page: 1, size: 10 }
) => {
  if (searchFilter.length > 0 && searchValue) {
    return {
      filters: searchFilter,
      search: { value: searchValue },
    };
  }
  if (searchFilter.length > 0 && !pageData) {
    return {
      filters: searchFilter,
    };
  }
  if (searchFilter.length > 0 && pageData) {
    return {
      filters: searchFilter,
      page: pageData.page,
      size: pageData.size,
    };
  }
  if (searchValue) {
    return {
      search: { value: searchValue },
    };
  }
  return {
    page: pageData.page,
    size: pageData.size,
  };
};

//PARA ACTUALIZAR LA DATA DE UNA TABLA AL EDITAR
export const updateDataWhenUpdate = (setEntities = () => {}, response) => {
  setEntities((prev) => prev.map((item) => (item.id === response.id ? response : item)));
};
export const updateDataWhenCreate = (setEntities = () => {}, response) => {
  setEntities((prev) => [response, ...prev]);
};
export const updateDataWhenDelete = (setEntities = () => {}, id) => {
  setEntities((prev) => prev.filter((prev) => prev.id !== id));
};

//helper para checar si un rol existe dentro de un array
export const hasRole = (roles = [], roleToCheck) => {
  return roles.includes(roleToCheck);
};
